import React, { useEffect } from 'react'
import { get as _get } from 'lodash'
import axios from 'axios'

import FacilityEditForm from '../leevo_ui/FacilityEditForm/FacilityEditForm'
import ApplicationLayout from '../leevo_ui/ApplicationLayout/ApplicationLayout'
import IndexHeader from '../leevo_ui/IndexHeader/IndexHeader'
import { requestCreator } from '../../utilities/requests'
import { mapFacilityPayload } from '../../utilities/apiPayloadMappers'
import useFacility from '../../utilities/hooks/useFacility'
import toast from '../../utilities/toast'

const { put: updateFacility, cancel: cancelFacilityRequest } = requestCreator()

function FacilityEditFeature() {
  const {
    facility,
    isLoading: isFacilityLoading,
    update: updateFacilityContext
  } = useFacility({
    isSubscriptionRequired: false
  })

  useEffect(() => {
    return cancelFacilityRequest
  }, [])

  function onSubmit(values) {
    return updateFacility(`/api/facilities/${facility.id}`, {
      facility: mapFacilityPayload(values)
    })
      .then(() => {
        toast.success('Changes saved!')
      })
      .catch((error) => {
        const message = _get(error, 'response.data.error') || 'We were unable to save your changes.'
        if (!axios.isCancel(error)) toast.error(message)
      })
  }

  return (
    <ApplicationLayout isContentLoading={isFacilityLoading}>
      <IndexHeader title="Settings" />
      <FacilityEditForm
        {...facility}
        onCardChange={({ id, isRemovingCard }) => {
          return updateFacility(`/api/facilities/${facility.id}`, {
            facility: mapFacilityPayload({ isRemovingCard, stripe_credit_card_token: id }),
            include: 'curriculums,billing_contact'
          }).then((updatedFacilityData) => {
            updateFacilityContext(updatedFacilityData)
          })
        }}
        onSubmit={onSubmit}
      />
    </ApplicationLayout>
  )
}

export default FacilityEditFeature
